<template>
  <Flex
    direction="column"
    :gap="0.5"
    padding
  >
    <BaseHeading size="xs">{{ $t('global.actions_label') }}</BaseHeading>
    <BaseCard noPadding>
      <div :class="$style.list">
        <Action
          v-for="(action, index) in actions"
          :key="index"
          :action="action"
          :tooltip="
              action.disabled && action.disabledTooltip
                ? {
                    text: action.disabledTooltip,
                    touch: true
                  }
                : null
            "
          v-component="action.component"
          @click="$emit('select', action.name)"
        />
      </div>
    </BaseCard>
  </Flex>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Action from './Action.vue';

export default defineComponent({
  name: 'ModalActions',
  components: {
    Action,
  },
  props: {
    actions: {
      type: Array,
      required: false,
      default: () => [],
      validator: (value) =>
        !value.length || !value.find((item) => !item.name || !item.label),
    },
  },
  emits: ['select'],
});
</script>

<style
  lang="scss"
  module
>
// Clip the rows to the card's rounded corners (minus its 1px border)
.list {
  border-radius: $radius * 2 - 1px;
  overflow: hidden;
}
</style>
